/* Draws the hand-drawn underlines when a KM section scrolls into view. */
(function () {
  if (window.__kmsInit) return;
  window.__kmsInit = true;
  function init() {
    var els = document.querySelectorAll('.kms, .km-intro');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { window.__kmsInit = false; });
})();
